import * as React from "react";
import { Button } from "primereact/button";
import { Alert } from "reactstrap";
import { ProgressBar } from "primereact/progressbar";
import { resolveAddress } from "../../../utils/position";
import { useAuth0 } from "../../../auth/react-auth0-wrapper";
import Can from "../../../auth/Can";
import roles from "../../../auth/roles";
import moment from 'moment';

export default function PositionTestAnswer({
    trigger,
    triggerNextStep,
    deviceId,
    step
}) {
    const { gisApi, domains } = useAuth0();

    const [loading, setLoading] = React.useState(false);
    const [positionResult, setPositionResult] = React.useState(
        step.value && step.value.completed ? step.value : undefined
    );
    const completed = step.value && step.value.completed;
    const error = step.value && step.value.error;

    const checkValidState = position => {
        return Number(position.attributes.sat) >= domains.appSettings.satLimit;
    };

    async function getPosition() {
        let ret;
        setLoading(true);
        const position = await gisApi.getLastPosition(deviceId);

        if (!position) {
            ret = {
                ok: false,
                error: `Impossibile rilevare la posizione. Si prega di riprovare.`
            };
        } else if (!checkValidState(position)) {

            ret = {
                ok: false,
                error: `Il numero di satelliti rilevato ${position.attributes.sat} risulta inferiore alla soglia minima stabilita di ${domains.appSettings.satLimit}`
            };
        } else {
            let address;
            try {
                address = await resolveAddress(position);
            } catch (error) {
                // unable to resolve address but we keep going
                console.log(error);
            }
            ret = { ok: true, position, address };
            const posRes = { position, address };
            setPositionResult(posRes);
        }
        setLoading(false);
        return ret;
    }

    return (
        <div>
            <Alert
                color={error ? "danger" : completed ? "success" : "info"}
                title={"Verifica della posizione"}
            >
                <div>
                    {loading && (
                        <div>
                            <div>{"Rilevamento della posizione in corso..."}</div>
                            <ProgressBar className="mb-2" mode="indeterminate" style={{ height: "8px" }} />
                        </div>
                    )}
                    {loading && !positionResult && (
                        <div>
                            <div>{"Al momento non rilevo nessuna posizione dal dispositivo, assicurarsi che si possa correttamente ricevere segnale GSM e satelliti."}</div>
                        </div>
                    )}
                    {error && <div>{error}</div>}
                    {positionResult && (
                        <div>
                            {`Posizione rilevata: satelliti ${positionResult.position.attributes.sat}, indirizzo: ${positionResult.address}`}
                        </div>
                    )}
                    {!error && !completed && positionResult && (
                        <div>
                            <div className="mb-2">{`La posizione è corretta?`}</div>
                            <Button
                                disabled={loading}
                                label={`SI`}
                                icon="pi pi-check"
                                style={{ marginRight: "5px" }}
                                onClick={() => {
                                    triggerNextStep({
                                        trigger: trigger,
                                        value: {
                                            position: positionResult.position,
                                            address: positionResult.address,
                                            completed: true, timestamp: moment().toJSON()
                                        }
                                    });
                                }}
                                className="p-button-success p-button-rounded"
                            />

                            <Button
                                disabled={loading}
                                label={`NO`}
                                icon="pi pi-times"
                                style={{ marginRight: "5px" }}
                                onClick={() => {
                                    triggerNextStep({
                                        trigger: step.id,
                                        value: {
                                            error: `Posizione rifiutata dall'operatore`, timestamp: moment().toJSON()
                                        }
                                    });
                                }}
                                className="p-button-danger p-button-rounded"
                            />
                        </div>
                    )}
                    {!error && !completed && !positionResult && (
                        <div>
                            <Button
                                disabled={loading}
                                label={`Rileva la posizione`}
                                icon="pi pi-check"
                                onClick={async () => {
                                    const positionReq = await getPosition();
                                    if (!positionReq.ok) {
                                        triggerNextStep({
                                            trigger: step.id,
                                            value: {
                                                error: positionReq.error, timestamp: moment().toJSON()
                                            }
                                        });
                                    }
                                }}
                                className="p-button-info p-button-rounded"
                            />
                            <Can
                                roles={[roles.ADMIN]}
                                yes={() =>
                                    <Button
                                        className="p-button-danger p-button-rounded ml-2"
                                        label={'FORZA TEST'}
                                        icon="fas fa-fast-forward"
                                        onClick={async () => {
                                            if (confirm('Confermi di voler forzare il test della posizione?')) {
                                                triggerNextStep({
                                                    trigger: 'test-posizione-end',
                                                    value: { skipped: true, completed: true, position: { attributes: { sat: "N.D." } }, address: "N.D.", timestamp: moment().toJSON() }
                                                });
                                            }
                                        }}
                                    />
                                }
                                no={() => null}
                            />
                        </div>
                    )}
                </div>
            </Alert>
        </div>
    );
}
